export default "__VITE_ASSET__230df2b5__"